<template>
  <div class="upload-list">
    <upload v-bind:key="upload.key" v-for="upload in uploads" v-bind="upload" v-on:delete="$emit('delete', $event)" v-bind:t="t" :openFullImageDialog="upload.key == fullImageId" />
    <div class="mt-4 text-center small" style="color: #98A0A6;">
      {{ t.dont_forget_to_download }}
    </div>
  </div>
</template>

<script>
import Upload from './upload';

export default {
  props: {
    uploads: Array,
    t: Object,
    fullImageId: String,
  },
  components: { Upload },
  data() {
    return {

    };
  },
  methods: {
  }
}
</script>

<style scoped>
  .upload-list {
    
  }
  @media(max-width: 575px) {
    .upload-list {
      margin-left: -15px;
      margin-right: -15px;
    }
  }
</style>
